$(document).ready(function () {
  window.theme = window.theme || {};
  window.notFirstLoad = false;

  $(".pp_selection_color_btn").mouseover(function () {
    $(this).addClass("hovered");
  });

  $(".pp_selection_color_btn").mouseleave(function () {
    $(".pp_selection_color_btn").removeClass("hovered");
  });

  $(".pp_selection_color_btn").click(function () {
    if (window.mmqLoaded) {
      window.setPreload();
      setTimeout(function () {
        window.removePreloads();
      }, 1000);
    }

    $(".oos-limit-reached_box.pdp").addClass("hided");
    $(this)
      .closest(".pp_opt_color")
      .find(".pp_selection_color_btn")
      .removeClass("active");
    $(this).addClass("active");

    var isCharity = false;
    if (
      $(".pp_opt_color_options_2 .pp_var_select__js.active").attr(
        "data-charity",
      ) == "true"
    ) {
      isCharity = true;
    }

    var selectedOption = $(this).attr("data-option-title");

    $(this)
      .closest(".pp_opt_color")
      .find(".charity-label__js")
      .each(function () {
        $(this).find("span").html(selectedOption);
      });

    var charityLabel = $(".pp_variants").attr("data-charity-label");

    $(this)
      .closest(".pp_opt_color")
      .find(".pp_variant_label_variant")
      .html(selectedOption);

    getVariant();

    // Rizer: hide incompatible top color when legs color is selected
    var $variants = $(this).closest('.pp_variants');
    var legsOption = $variants.data('rizer-legs');
    if ($variants.data('rizer-enabled') && legsOption && $(this).attr('data-option-name') === legsOption) {
      var legsBlack = $variants.data('rizer-legs-black');
      var topWhite  = $variants.data('rizer-top');
      var legsValue = $(this).attr('data-option-title');
      $variants.find('.pp_selection_color_btn').each(function () {
        if ($(this).attr('data-option-name') === legsOption) return;
        var title = $(this).attr('data-option-title');
        var hide = (legsValue === legsBlack && title === topWhite) ||
                   (legsValue === topWhite  && title === legsBlack);
        $(this).toggleClass('rizer-top-hidden', hide);
      });

      // If the active top button is now hidden, auto-select the matching top color
      var $activeTop = $variants.find('.pp_selection_color_btn.active').filter(function () {
        return $(this).attr('data-option-name') !== legsOption;
      });
      if ($activeTop.hasClass('rizer-top-hidden')) {
        $variants.find('.pp_selection_color_btn').filter(function () {
          return $(this).attr('data-option-name') !== legsOption &&
                 $(this).attr('data-option-title') === legsValue;
        }).first().trigger('click');
      }
    }

    var mmqBlock = $(this).attr("data-mmq-block");
    var mmqCode = $(this).attr("data-mmq-code");

    console.log(mmqBlock, mmqCode);

    if (window.mmqLoaded) {
      window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
        mmqBlock,
        mmqCode,
      );
    }
  });

  $(".pp_selection_size_btn").click(function () {
    if (window.mmqLoaded) {
      window.setPreload();
      setTimeout(function () {
        window.removePreloads();
      }, 1000);
    }

    $(".oos-limit-reached_box.pdp").addClass("hided");
    $(this)
      .closest(".pp_opt_color")
      .find(".pp_selection_size_btn")
      .removeClass("active");
    $(this).addClass("active");
    getVariant();

    var selectedOption = $(this).attr("data-option-title");
    $(this)
      .closest(".pp_opt_color")
      .find(".pp_variant_label_variant")
      .html(selectedOption);

    var mmqBlock = $(this).attr("data-mmq-block");
    var mmqCode = $(this).attr("data-mmq-code");

    console.log(mmqBlock, mmqCode);

    if (window.mmqLoaded) {
      window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
        mmqBlock,
        mmqCode,
      );
    }

    // For specifications
    var specOption = String($(this).attr("data-value")).replace("-cm", "");
    specOption = specOption.split("x");
    specOption = specOption[0];
    console.log(specOption, "SPEC OPTION IS");
    $('.product_tabletop-nav-btn[data="' + specOption + '"]').trigger("click");
  });

  window.firstloadYetActed = false;

  function getVariant() {
    var variantTitle = "";

    $(".pp_var_select__js.active").each(function () {
      var currentTitle = $(this).attr("data-value");
      variantTitle += currentTitle + "-";
    });

    // Accessories included change on option1 color
    var $buttons = $(".pp_opt_color_options_1 .pp_var_select__js");
    var $active = $buttons.filter(".active");
    if ($active.length) {
      var index = $buttons.index($active) + 1;
      var $img1 = $(".included-accessories__image.option-1");
      var $img2 = $(".included-accessories__image.option-2");
      var imgs = [$img1, $img2];
      imgs.forEach(function ($img) {
        $img.addClass("hide");
      });
      if (index > imgs.length) {
        index = 1;
      }
      imgs[index - 1].removeClass("hide");
    }

    // Accessories included change on option1 color
    var $buttons = $(".pp_opt_color_options_1 .pp_var_select__js");
    var $active = $buttons.filter(".active");
    if ($active.length) {
      var index = $buttons.index($active) + 1;
      var $img1 = $(".included-accessories__image.option-1");
      var $img2 = $(".included-accessories__image.option-2");
      var imgs = [$img1, $img2];
      imgs.forEach(function ($img) {
        $img.addClass("hide");
      });
      if (index > imgs.length) {
        index = 1;
      }
      imgs[index - 1].removeClass("hide");
    }

    variantTitle = variantTitle.slice(0, -1);

    var $variantElement = $(
      '.pp_variant_config[data-title="' + variantTitle + '"]',
    );
    var variantId = $variantElement.attr("data-id");

    // console.log(variantTitle, "variantTitle");

    // console.log('Selected Variant Title:', variantTitle);
    // console.log('Selected Variant ID:', variantId);

    if (variantId) {
      updateURLParameter("variant", variantId);
    }

    // console.log(variantId, 'VARIANT ID =================');

    if (typeof variantId != "undefined") {
      setVariant(variantId);
      setPrice(variantId);
      setStock(variantId);
      setAddons(variantId);
      if (window.firstloadYetActed == true) {
        setGalleryFirst();
      }
      window.firstloadYetActed = true;
    }

    // For specifications
    var activeTabletopMode = $(".pp_opt_color_options_2")
      .find(".pp_var_select__js.active")
      .closest(".pp_sellection_color_block")
      .attr("data-type");
    // console.log(activeTabletopMode, 'ACTIVE TABLETOP')
    if (activeTabletopMode == "premium") {
      $('.product_spec-tabletops-switcher-btn[data="premium"]').trigger(
        "click",
      );
    } else {
      $('.product_spec-tabletops-switcher-btn[data="classic"]').trigger(
        "click",
      );
    }

    if (variantTitle.indexOf("140x70") !== -1) {
      $(".pp_size-warning-outer").removeClass("hidedWarn");
    } else {
      $(".pp_size-warning-outer").addClass("hidedWarn");
    }

    setDeliveryMessage();
  }

  function setDeliveryMessage() {
    var neededOption = $(".delivery_messageData").attr("data-option");
    var customMessagesExists = false;

    $("[is-atc-date_specific]").each(function () {
      if ($(this).attr("data-option") == neededOption) {
        customMessagesExists = true;
      }
    });

    // console.log(customMessagesExists, 'CUSTOM MESSAGES EXISTS FOR THIS PRODUCT');

    if (customMessagesExists == true) {
    } else {
      $("[is-atc-date_specific]").addClass("hided");
      $("[is-atc-date]").removeClass("hided");
    }
    $(".pp_var_select__js.active").each(function () {
      if ($(this).attr("data-option-name") == neededOption) {
        var currentVal = $(this).attr("data-option-title");
        $(".product-single__shipping-date").addClass("hided");

        var $target = $(
          '.product-single__shipping-date[data-color="' + currentVal + '"]',
        );

        if ($target.length) {
          // element found
          $target.removeClass("hided");
        } else {
          $("[is-atc-date]").removeClass("hided");
        }
      }
    });
  }

  function setGalleryFirst() {
    filterImages();
  }

  var loopId = setInterval(function () {
    getVariant();
    if (window.stockLoaded === true) {
      clearInterval(loopId);
    }
  }, 200);

  $(".custom-mobile-buttons__next").click(function () {
    window.pdpSwiper.slideNext();
  });

  $(".custom-mobile-buttons__prev").click(function () {
    window.pdpSwiper.slidePrev();
  });

  $(".product_main_gallery_thumbs__js .slider__gallery-item-btn_next").click(
    function () {
      window.pdpSwiper.slideNext();
      $(
        ".product_main_gallery_thumbs__js .slider__gallery-item-btn_prev",
      ).removeClass("swiper-button-disabled");
    },
  );

  $(".product_main_gallery_thumbs__js .slider__gallery-item-btn_prev").click(
    function () {
      window.pdpSwiper.slidePrev();
      $(
        ".product_main_gallery_thumbs__js .slider__gallery-item-btn_next",
      ).removeClass("swiper-button-disabled");
    },
  );

  window.filteringActive = false;
  // function filterImages(){
  //     window.filteringActive = true;
  //     setTimeout(function(){
  //         window.filteringActive = false
  //     },500);
  //     var currentOption1 = $('.pp_opt_color_options_1').find('.pp_selection_color_btn.pp_var_select__js.active').attr('data-option-title');
  //     var currentOption2 = $('.pp_opt_color_options_2').find('.pp_selection_color_btn.pp_var_select__js.active').attr('data-option-title');
  //     var currentOptionString = currentOption1 + ' / ' + currentOption2;

  //     console.log(currentOptionString, 'currentOptionString');

  //     var newImagesBlock = 'none';
  //     var newImagesBlockThumbs = 'none';
  //     var popupImages = 'none';
  //     var popupImagesThumbs = 'none';
  //     $('.product_specific-images-block').each(function(){
  //         if ($(this).attr('data') == currentOptionString){
  //             newImagesBlock  = $(this).html();
  //         }
  //     });
  //     if (newImagesBlock == 'none'){
  //         newImagesBlock = $('.product_specific-images-block[data="all"]').html();
  //     }

  //     $('.product_specific-images-block-thumbs').each(function(){
  //         if ($(this).attr('data') == currentOptionString){
  //             newImagesBlockThumbs  = $(this).html();
  //         }
  //     });
  //     if (newImagesBlockThumbs == 'none'){
  //         newImagesBlockThumbs = $('.product_specific-images-block-thumbs[data="all"]').html();
  //     }

  //     $('.product_specific-images-block-modal').each(function(){
  //         if ($(this).attr('data') == currentOptionString){
  //             popupImages  = $(this).html();
  //         }
  //     });
  //     if (popupImages == 'none'){
  //         popupImages = $('.product_specific-images-block-modal[data="all"]').html();
  //     }

  //     $('.product_specific-images-block-modal_thumbs').each(function(){
  //         if ($(this).attr('data') == currentOptionString){
  //             popupImagesThumbs  = $(this).html();
  //         }
  //     });
  //     if (popupImagesThumbs == 'none'){
  //         popupImagesThumbs = $('.product_specific-images-block-modal_thumbs[data="all"]').html();
  //     }

  //     $(".product-single__thumbnails li:not(:first)").remove();
  //     $('.product-single__media-group').find('.product-single__media-flex-wrapper').not(':first').remove();

  //     $('.product-single__thumbnails li').first().after(newImagesBlockThumbs);
  //     $('.product-single__media-group').find('.product-single__media-flex-wrapper').first().after(newImagesBlock);

  //     $('.media--modal__images .swiper-wrapper .media--modal__slide').not(':first').remove();
  //     $('.media--modal__slide--list .media--modal__slide').not(':first').remove();

  //     $('.media--modal__images .swiper-wrapper .media--modal__slide').first().after(popupImages);
  //     $('.media--modal__slide--list .media--modal__slide').first().after(popupImagesThumbs);

  //     window.resetSwipers();
  // }

  function fromTemplate(selector, key) {
    const source = document.getElementById("product-images-tmpl").content; // DocumentFragment
    let html = "none";

    // exact match
    source.querySelectorAll(selector).forEach((el) => {
      if (el.getAttribute("data") === key) html = el.innerHTML;
    });

    // fallback to [data="all"]
    if (html === "none") {
      const all = source.querySelector(`${selector}[data="all"]`);
      if (all) html = all.innerHTML;
    }
    return html;
  }

  function filterImages() {
    window.filteringActive = true;
    setTimeout(() => (window.filteringActive = false), 500);

    const currentOption1 =
      $(
        ".pp_opt_color_options_1 .pp_selection_color_btn.pp_var_select__js.active",
      ).attr("data-option-title") || "";

    let currentOption2 = $(
      ".pp_opt_color_options_2 .pp_selection_color_btn.pp_var_select__js.active",
    ).attr("data-option-title");

    if (!currentOption2) {
      currentOption2 = $(
        ".pp_opt_color_options_2 .pp_images-set-button.pp_var_select__js.active",
      ).attr("data-option-title");
    }

    const currentOptionString = currentOption2
      ? `${currentOption1} / ${currentOption2}`
      : currentOption1;

    if (!currentOptionString) return;

    // console.log(currentOptionString, "currentOptionString");

    const newImagesBlock = fromTemplate(
      ".product_specific-images-block",
      currentOptionString,
    );
    const newImagesBlockThumbs = fromTemplate(
      ".product_specific-images-block-thumbs",
      currentOptionString,
    );
    const popupImages = fromTemplate(
      ".product_specific-images-block-modal",
      currentOptionString,
    );
    const popupImagesThumbs = fromTemplate(
      ".product_specific-images-block-modal_thumbs",
      currentOptionString,
    );

    // clear current UI
    $(".product-single__thumbnails li:not(:first)").remove();
    $(".product-single__media-group .product-single__media-flex-wrapper")
      .not(":first")
      .remove();

    // inject selected HTML
    $(".product-single__thumbnails li").first().after(newImagesBlockThumbs);
    $(".product-single__media-group .product-single__media-flex-wrapper")
      .first()
      .after(newImagesBlock);

    $(".media--modal__images .swiper-wrapper .media--modal__slide")
      .not(":first")
      .remove();
    $(".media--modal__slide--list .media--modal__slide").not(":first").remove();

    $(".media--modal__images .swiper-wrapper .media--modal__slide")
      .first()
      .after(popupImages);
    $(".media--modal__slide--list .media--modal__slide")
      .first()
      .after(popupImagesThumbs);

    window.resetSwipers();
  }

  function setVariant(variantId) {
    // console.log(variantId, "VARIANT ID");
    var variantSrc = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
      "data-featured-img",
    );
    $("#product-variant__src").attr("src", variantSrc);
    $("#product-variant__thumb").attr("src", variantSrc);

    $(".pp_config__main_id-js").attr("data-id", variantId);
    $("#ProductPrice").attr("data-variant-id", variantId);
    $("#PriceDiscount").attr("data-variant-id", variantId);
    $("#ComparePrice").attr("data-variant-id", variantId);
    $(".product_thumb-sticky").attr("src", variantSrc);

    var variantBadge = $(
      '.pp_variant_config[data-id="' + variantId + '"]',
    ).attr("data-made-in-badge");
    if (variantBadge == "true") {
      $(".pp_media-made-in-badge").show();
    } else {
      $(".pp_media-made-in-badge").hide();
    }
  }

  function setPrice(variantId) {
    var currentPrice = $(
      '.pp_variant_config[data-id="' + variantId + '"]',
    ).attr("data-price");
    var currentCompare = $(
      '.pp_variant_config[data-id="' + variantId + '"]',
    ).attr("data-compare");
    var currentDiscount = $(
      '.pp_variant_config[data-id="' + variantId + '"]',
    ).attr("data-discount");
    if (currentDiscount == "false") {
      $("#ProductPrice").html(currentPrice);
      $("#ComparePrice").html("");
      $("#PriceDiscount").html("");
      $('.product-single__30days-price').hide();
      $('.product-single_price_info_line>div:nth-child(2)').removeClass('day30Visible');
    } else {
      $("#ProductPrice").html(currentPrice);
      $("#ComparePrice").html(currentCompare);
      $("#PriceDiscount").html(currentDiscount);
      $('.product-single__30days-price').show();
      $('.product-single_price_info_line>div:nth-child(2)').addClass('day30Visible');
    }
    var $thirtyDaysPrice = $(".product-single__30days-price-variant");
    var min30Raw = $(
      '.pp_variant_config[data-id="' + variantId + '"]',
    ).attr('data-min-pricing-30');
    $thirtyDaysPrice.html(min30Raw );
  }

  function updateURLParameter(param, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(param, value);
    window.history.replaceState({}, "", url);
  }

  function getUrlParameters() {
    var params = {};
    var queryString = window.location.search.substring(1); // Remove the '?'

    if (queryString) {
      var pairs = queryString.split("&");
      $.each(pairs, function (i, pair) {
        var parts = pair.split("=");
        var key = decodeURIComponent(parts[0]);
        var value = decodeURIComponent(parts[1] || "");
        params[key] = value;
      });
    }

    return params;
  }

  function setDefault() {
    var urlParams = getUrlParameters();
    var variantId = urlParams["variant"];
    if (!variantId) {
      $("#product-variant__src").addClass("active");
      variantId = $(".pp_variant_config").first().attr("data-id");
    }

    // Selection for size product
    var currentProductId = $(
      '.pp_variant_config[data-id="' + variantId + '"]',
    ).attr("data-product-id");

    var option1 = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
      "data-option1",
    );
    var option2 = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
      "data-option2",
    );
    var option3 = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
      "data-option3",
    );

    console.log(option1, option2, option3);

    $("#product-variant__src").addClass("active");

    // Stock preparation
    var stock = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
      "data-stock",
    );
    if (stock == "0") {
    } else {
    }
    // console.log(stock, 'STOCK');

    window.notFirstLoad = true;
  }

  setDefault();

  window.stockLoaded = false;

  function setStock(variantId) {
    $(".pp_var_select__js").removeClass("soldOut");

    var optionGroupCount = $(".pp_opt_color").length;
    var variantTitle = "";

    var selectedSize =
      $(".pp_selection_size_btn.pp_var_select__js.active").attr("data-value") ||
      "";
    var selectedOption1 =
      $(".pp_opt_color_options_1 .pp_var_select__js.active").attr(
        "data-value",
      ) || "";
    var selectedOption2 =
      $(".pp_opt_color_options_2 .pp_var_select__js.active").attr(
        "data-value",
      ) || "";

    if (optionGroupCount >= 3) {
      $(".pp_opt_color_options_1 .pp_var_select__js.active").each(function () {
        var option1Value = $(this).attr("data-value");
        $(".pp_opt_color_options_2 .pp_var_select__js").each(function () {
          var option2Value = $(this).attr("data-value");
          variantTitle = option1Value + "-" + option2Value + "-" + selectedSize;
          var stockValue = $(
            '.pp_variant_config[data-title="' + variantTitle + '"]',
          ).attr("data-stock");
          if (stockValue === "0") $(this).addClass("soldOut");
        });
      });

      $(".pp_opt_color_options_2 .pp_var_select__js.active").each(function () {
        var option2Value = $(this).attr("data-value");
        $(".pp_opt_color_options_1 .pp_var_select__js").each(function () {
          var option1Value = $(this).attr("data-value");
          variantTitle = option1Value + "-" + option2Value + "-" + selectedSize;
          var stockValue = $(
            '.pp_variant_config[data-title="' + variantTitle + '"]',
          ).attr("data-stock");
          if (stockValue === "0") $(this).addClass("soldOut");
        });
      });

      var activeOption1 =
        $(".pp_opt_color_options_1 .pp_var_select__js.active").attr(
          "data-value",
        ) || "";
      var activeOption2 =
        $(".pp_opt_color_options_2 .pp_var_select__js.active").attr(
          "data-value",
        ) || "";
      $(".pp_opt_color_options_3 .pp_var_select__js").each(function () {
        var sizeValue = $(this).attr("data-value");
        variantTitle = activeOption1 + "-" + activeOption2 + "-" + sizeValue;
        var stockValue = $(
          '.pp_variant_config[data-title="' + variantTitle + '"]',
        ).attr("data-stock");
        if (stockValue === "0") $(this).addClass("soldOut");
      });
    } else if (optionGroupCount === 2) {
      $(".pp_opt_color_options_2 .pp_var_select__js").each(function () {
        var option2Value = $(this).attr("data-value");
        variantTitle = selectedOption1 + "-" + option2Value;
        var stockValue = $(
          '.pp_variant_config[data-title="' + variantTitle + '"]',
        ).attr("data-stock");
        if (stockValue === "0") $(this).addClass("soldOut");
      });

      $(".pp_opt_color_options_1 .pp_var_select__js").each(function () {
        var option1Value = $(this).attr("data-value");
        variantTitle = option1Value + "-" + selectedOption2;
        var stockValue = $(
          '.pp_variant_config[data-title="' + variantTitle + '"]',
        ).attr("data-stock");
        if (stockValue === "0") $(this).addClass("soldOut");
      });
    } else {
      // Single option: mirror original behavior (check every option button)
      $(".pp_var_select__js").each(function () {
        variantTitle = $(this).attr("data-value");
        var stockValue = $(
          '.pp_variant_config[data-title="' + variantTitle + '"]',
        ).attr("data-stock");
        if (stockValue === "0") $(this).addClass("soldOut");
      });
    }

    if (typeof variantId !== "undefined") {
      var currentStockValue = $(
        '.pp_variant_config[data-id="' + variantId + '"]',
      ).attr("data-stock");
      if (currentStockValue === "0") {
        $(".product-single__buy-wrapper").addClass("disabled");
        $(".product__out-of-stock").addClass("active");
        $(".mobile-sticky-atc-btn__wrapper").addClass("disabled");
        $(".mobile-sticky-sold-out-btn__wrapper").removeClass("disabled");
        $("#tidio-chat").addClass("outOfStockVisible");
      } else {
        $(".product-single__buy-wrapper").removeClass("disabled");
        $(".product__out-of-stock").removeClass("active");
        $(".mobile-sticky-sold-out-btn__wrapper").addClass("disabled");
        $(".mobile-sticky-atc-btn__wrapper").removeClass("disabled");
        $("#tidio-chat").removeClass("outOfStockVisible");
      }

      window.stockLoaded = true;
    }

    // console.log("TESTING STOCK!!!!");
  }

  function setAddons(variantId) {
    var currentAddOnMode = $(
      '.pp_variant_config[data-id="' + variantId + '"]',
    ).attr("data-disabled-addon");
    // console.log(currentAddOnMode, 'addon mode');
    if (currentAddOnMode == "true") {
      $(".addons_free-gift_note").addClass("hided");
      $(".data-identifier-disabled").addClass("add-one-disabled");
      $(".product-single_free_gift_badge").addClass("hided");
      $(".data-identifier-disabled")
        .find(".addOneMainInput__js")
        .prop("checked", false);

      var productQnt = 1;
      $(".add-one__3d-checked input:checked").each(function () {
        productQnt++;
      });

      //   console.log(productQnt, ' quantity');
      if (productQnt > 1) {
        var atcText = $(".js-custom-add-to-cart")
          .attr("data-title-qnt")
          .replace("{}", productQnt);
        $(".desk_btn_content").find("span").html(atcText);
        $(".mobile-sticky-atc-btn__handlers")
          .find(".desk_btn_content")
          .html(atcText);
      } else {
        var atcText = $(".js-custom-add-to-cart").attr("data-title");
        $(".desk_btn_content").find("span").html(atcText);
        $(".mobile-sticky-atc-btn__handlers")
          .find(".desk_btn_content")
          .html(atcText);
      }
    } else {
      $(".data-identifier-disabled").removeClass("add-one-disabled");
      $(".addons_free-gift_note").removeClass("hided");
      $(".product-single_free_gift_badge").removeClass("hided");
    }
  }

  $(".product_price-popup-trigger").click(function () {
    $(".product-price-comparison_outer").css("display", "flex");
    $(".product-price-outer_whole").show();
    $("body").addClass("popup-open");
  });

  $(".product-price-popup_close").click(function () {
    $(".product-price-comparison_outer").hide();
    $(".product-price-outer_whole").hide();
    $("body").removeClass("popup-open");
  });

  $(".product-colors-popup_close").click(function () {
    $(".product-colors-comparison_outer").hide();
    $(".product-comparison-outer_whole").hide();
    $("body").removeClass("popup-open");
  });

  $(".pp_colors_info").click(function () {
    var currentData = $(this).attr("data");
    $('.product-comparison-outer_whole[data="' + currentData + '"]')
      .find(".product-colors-comparison_outer")
      .css("display", "flex");
    $('.product-comparison-outer_whole[data="' + currentData + '"]').show();
    $("body").addClass("popup-open");
  });

  $(".product-charity-popup_close").click(function (evt) {
    evt.preventDefault();
    $(".product-charity-outer_whole").hide();
    $("body").removeClass("popup-open");
  });

  $(".charity-note_line").on("click", function (evt) {
    const screenWidth = $(window).width();
    const target = $(evt.target);

    if (target.is(".charity-label__js")) {
      if (screenWidth < 678) {
        evt.preventDefault();
        $(".product-charity-outer_whole").show();
        $("body").addClass("popup-open");
        $(".product-charity-comparison_outer").css("display", "flex");
        var winHeight = $(window).height();
        if (winHeight > 1000) {
          if ($(window).width() > 678) {
            var popupHeight = $(
              ".product-charity-comparison_popup",
            ).outerHeight();
            $(".product-charity-popup_close").css(
              "top",
              "calc(50% - " + popupHeight / 2 + "px + 16px)",
            );
            $(".product-charity-comparison_outer").css("align-items", "center");
          }
        } else {
          $(".product-charity-comparison_outer").css(
            "align-items",
            "flex-start",
          );
          $(".product-charity-popup_close").css("top", "72px");
        }
      } else {
        // Do nothing if screenWidth >= 678 and clicked element is a <p>
      }
    } else if (target.is("a")) {
      evt.preventDefault();
      $(".product-charity-outer_whole").show();
      $("body").addClass("popup-open");
      $(".product-charity-comparison_outer").css("display", "flex");
      var winHeight = $(window).height();
      if (winHeight > 1000) {
        if ($(window).width() > 678) {
          var popupHeight = $(
            ".product-charity-comparison_popup",
          ).outerHeight();
          $(".product-charity-popup_close").css(
            "top",
            "calc(50% - " + popupHeight / 2 + "px + 16px)",
          );
          $(".product-charity-comparison_outer").css("align-items", "center");
        }
      } else {
        $(".product-charity-comparison_outer").css("align-items", "flex-start");
        $(".product-charity-popup_close").css("top", "72px");
      }
    }
  });

  $(".form_input-line input").on("input", function () {
    var $inputLine = $(this).closest(".form_input-line");

    if ($(this).val().trim() !== "") {
      $inputLine.addClass("hasValue");

      var inputType = $(this).attr("data-type");
      if (inputType === "email") {
        var value = $(this).val().trim();
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (emailRegex.test(value)) {
          $inputLine.removeClass("invalid");
        } else {
          $inputLine.addClass("invalid");
        }
      }

      if (inputType == "web") {
        var value = $(this).val();
        if (String(value).indexOf(".") > 0) {
          $inputLine.removeClass("invalid");
        } else {
          $inputLine.addClass("invalid");
        }
      }
    } else {
      $inputLine.removeClass("hasValue");
      $inputLine.removeClass("invalid");
    }
  });

  $(".form_input-line").click(function () {
    var input = $(this).find("input");
    input.focus();
    $(".form_input-line").removeClass("active");
    $(this).addClass("active");
  });

  $(".price_match-submit").click(function (e) {
    e.preventDefault();
    var formValid = true;
    $(".form_input-line").each(function () {
      if ($(this).hasClass("invalid")) {
      } else {
        var value = $(this).find("input").val();
        if (value.trim() == "") {
          $(this).addClass("invalid");
        } else {
          $(this).removeClass("invalid");
        }
      }
    });

    $(".form_input-line").each(function () {
      if ($(this).hasClass("invalid")) {
        formValid = false;
      }
    });
    // alert(formValid);

    if (formValid == true) {
      window.submitPriceMathcKlaviyo();
      $(this).closest("form").submit();
    }
    // $('.product-price-comparison_popup').addClass('submited');
  });

  // $(".product-single__add-one").click(function () {
  //   setTimeout(function () {
  //     if ($(".product_selection-all-box").hasClass("preloadNone")) {
  //     } else {
  //       window.setPreload();
  //     }
  //   }, 100);
  // });

  $(".product-single_free_gift_badge").mouseover(function () {
    $(this).find(".product-single_free_gift_tooltip").show();
  });

  $(".product-single_free_gift_badge").mouseleave(function () {
    $(this).find(".product-single_free_gift_tooltip").hide();
  });

  $(document).on(
    "click",
    ".mobile-sticky-sold-out-btn__wrapper button",
    function () {
      $("#productOut")[0].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
  );

  // Switch between add-on products addon card
  $(document).on(
    "click",
    ".add--one--modal__handler--box .addone_item-switch",
    function () {
      $(".add--one--modal__handler--box").addClass("loading");
      setTimeout(function () {
        $(".add--one--modal__handler--box").removeClass("loading");
      }, 500);
      // console.log('Clicked from popup');
      $(this)
        .closest(".addone_items-product-switch")
        .find(".addone_item-switch")
        .removeClass("active");
      $(this).addClass("active");
      var data = $(this).attr("data");

      var productId = $(this)
        .closest(".addone_items-product-switch")
        .attr("data-product-id");

      var productIdReal = $(this).attr("data-product-id");
      $(".add--one--modal__content").attr("data-product-id", productIdReal);
      $('.product-single__add-one[id="addone-' + productId + '"]').attr(
        "data-id",
        productIdReal,
      );

      var ratingScore = $(this).attr("data-reviews-rating");
      $('.product-single__add-one[id="addone-' + productId + '"]')
        .find(".add-one_rating_count p")
        .html(ratingScore);

      var ratingScoreInt = parseFloat(ratingScore);
      if (ratingScoreInt < 0.5) {
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one_rating_line")
          .css("opacity", "0");
        $("#mainProduct").addClass("reviewsHided");
      } else {
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one_rating_line")
          .css("opacity", "1");
        $("#mainProduct").removeClass("reviewsHided");
      }

      // console.log(productId, data, 'HRERERE');
      $(
        '.addone_items-product-switch__outer .addone_items-product-switch[data-product-id="' +
          productId +
          '"]',
      )
        .find(".addone_item-switch")
        .removeClass("active");
      $(
        '.addone_items-product-switch__outer .addone_items-product-switch[data-product-id="' +
          productId +
          '"]',
      )
        .find('.addone_item-switch[data="' + data + '"]')
        .addClass("active");

      // SwitchPopupData

      $('.product-single__add-one[id="addone-' + productId + '"]')
        .find(".add-one__variants")
        .addClass("hided");
      $('.product-single__add-one[id="addone-' + productId + '"]')
        .find('.add-one__variants[data="' + data + '"]')
        .removeClass("hided");

      if (data == "org") {
        var selectedBubble = $(
          '.product-single__add-one[id="addone-' + productId + '"]',
        ).find(".product__additional-variant input:checked");

        var newVariantId = selectedBubble.attr("data-id");
        var newPrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-price");
        var newComparePrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-compare-price");
        var newBadge = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-discount");
        var newImage = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-src");

        var mmqBlock = selectedBubble.attr("data-mmq-block");
        var mmqCode = selectedBubble.attr("data-mmq-code");

        // console.log(newVariantId, newPrice, newComparePrice, newBadge, newImage, mmqBlock, mmqCode);

        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".addOneMainInput__js")
          .attr("data-mmq-block", mmqBlock);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".addOneMainInput__js")
          .attr("data-mmq-code", mmqCode);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".addOneMainInput__js")
          .attr("data-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__image img")
          .attr("src", newImage);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-current")
          .html(newPrice);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-compare-at__money")
          .html(newComparePrice);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-current")
          .attr("data-variant-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-compare-at__money")
          .attr("data-variant-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__discount")
          .attr("data-variant-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__discount")
          .html(newBadge);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__popup-opener")
          .attr("data-product-id", productIdReal);

        resetPopupDate(newVariantId);
        window.calculateTabs(productIdReal, newVariantId);
      } else {
        var selectedBubble = $(
          '.product-single__add-one[id="addone-' + productId + '"]',
        ).find(".addone_color-option-out.active");
        var newVariantId = selectedBubble.attr("data-variant-id");
        var newImage = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-src");
        var newPrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-price");
        var newComparePrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-compare-price");
        var newBadge = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-discount");

        var mmqBlock = selectedBubble.attr("data-mmq-block");
        var mmqCode = selectedBubble.attr("data-mmq-code");

        // console.log(newVariantId, newPrice, newComparePrice, newBadge, newImage, mmqBlock, mmqCode);

        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".addOneMainInput__js")
          .attr("data-mmq-block", mmqBlock);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".addOneMainInput__js")
          .attr("data-mmq-code", mmqCode);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".addOneMainInput__js")
          .attr("data-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__image img")
          .attr("src", newImage);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-current")
          .html(newPrice);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-compare-at__money")
          .html(newComparePrice);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-current")
          .attr("data-variant-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__prices-compare-at__money")
          .attr("data-variant-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__discount")
          .attr("data-variant-id", newVariantId);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__discount")
          .html(newBadge);
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__popup-opener")
          .attr("data-product-id", productIdReal);

        window.calculateTabs(productIdReal, newVariantId);
        resetPopupDate(newVariantId);
      }

      $(".modal--color__label.activelabel span").trigger("click");
    },
  );

  function resetPopupDate(variantId) {
    var newTitle = $('.pa_label_variant__js[data-id="' + variantId + '"]').attr(
      "data-popup-title",
    );
    var newDescription = $(
      '.pa_label_variant__js[data-id="' + variantId + '"]',
    ).attr("data-popup-description");
    var newbuttonText = $(".pdp_variables_for_popups").data("more");
    var newUrl = $('.pa_label_variant__js[data-id="' + variantId + '"]').attr(
      "data-url",
    );
    var newRating = $(
      '.pa_label_variant__js[data-id="' + variantId + '"]',
    ).attr("data-popup-rating");

    console.log(newTitle);

    $(".add--one--modal__info--title").html(newTitle);
    $(".add--one--modal__info--description").html(
      newDescription + ` <a href="${newUrl}">${newbuttonText}</a>`,
    );
    $(".add-one_rating_line").html(newRating);
  }

  // Switch between add-on products actual card
  $(".addone_item-switch").click(function () {
    $(this)
      .closest(".addone_items-product-switch")
      .find(".addone_item-switch")
      .removeClass("active");
    $(this).addClass("active");
    var data = $(this).attr("data");
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__variants")
      .addClass("hided");
    $(this)
      .closest(".product-single__add-one")
      .find('.add-one__variants[data="' + data + '"]')
      .removeClass("hided");

    var ratingScore = $(this).attr("data-reviews-rating");
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one_rating_count p")
      .html(ratingScore);

    var ratingScoreInt = parseFloat(ratingScore);
    if (ratingScoreInt < 0.5) {
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one_rating_line")
        .css("opacity", "0");
      $("#mainProduct").addClass("reviewsHided");
    } else {
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one_rating_line")
        .css("opacity", "1");
      $("#mainProduct").removeClass("reviewsHided");
    }

    var productId = $(this).attr("data-product-id");
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__popup-opener")
      .attr("data-product-id", productId);
    $(this).closest(".product-single__add-one").attr("data-id", productId);

    if (data == "org") {
      var selectedBubble = $(this)
        .closest(".product-single__add-one")
        .find(".product__additional-variant input:checked");

      var newVariantId = selectedBubble.attr("data-id");
      var newPrice = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-price");
      var newComparePrice = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-compare-price");
      var newBadge = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-discount");
      var newImage = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-src");

      var mmqBlock = selectedBubble.attr("data-mmq-block");
      var mmqCode = selectedBubble.attr("data-mmq-code");

      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-mmq-block", mmqBlock);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-mmq-code", mmqCode);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__image img")
        .attr("src", newImage);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-current")
        .html(newPrice);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-compare-at__money")
        .html(newComparePrice);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-current")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-compare-at__money")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__discount")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__discount")
        .html(newBadge);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__popup-opener")
        .attr("data-product-id", productId);
    } else {
      var selectedBubble = $(this)
        .closest(".product-single__add-one")
        .find(".addone_color-option-out.active");
      var newVariantId = selectedBubble.attr("data-variant-id");
      var newImage = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-src");
      var newPrice = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-price");
      var newComparePrice = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-compare-price");
      var newBadge = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-discount");

      var mmqBlock = selectedBubble.attr("data-mmq-block");
      var mmqCode = selectedBubble.attr("data-mmq-code");

      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-mmq-block", mmqBlock);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-mmq-code", mmqCode);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__image img")
        .attr("src", newImage);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-current")
        .html(newPrice);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-compare-at__money")
        .html(newComparePrice);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-current")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-compare-at__money")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__discount")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__discount")
        .html(newBadge);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__popup-opener")
        .attr("data-product-id", productId);
    }

    $(this)
      .closest(".product-single__add-one")
      .find(".addOneMainInput__js")
      .prop("checked", true);
    $(this)
      .closest(".product-single__add-one")
      .find(".addOneMainInput__js")
      .trigger("change");
  });

  $(".addone_color-option-out").click(function () {
    if ($(this).hasClass("disabled")) {
      return;
    }
    $(this)
      .closest(".product-single__add-one")
      .find(".addone_color-option-out")
      .removeClass("active");
    $(this).addClass("active");

    var selectedBubble = $(this)
      .closest(".product-single__add-one")
      .find(".addone_color-option-out.active");
    var newVariantId = selectedBubble.attr("data-variant-id");
    var newImage = $(
      '.pa_label_variant__js[data-id="' + newVariantId + '"]',
    ).attr("data-src");
    var newPrice = selectedBubble.attr("data-variant-price");
    var newComparePrice = selectedBubble.attr("data-variant-compare-price");
    var newBadge = $(
      '.pa_label_variant__js[data-id="' + newVariantId + '"]',
    ).attr("data-discount");
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__image img")
      .attr("src", newImage);
     
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-current")
      .html(newPrice);
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-compare-at__money")
      .html(newComparePrice);

    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-current")
      .attr("data-variant-id", newVariantId);
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-compare-at__money")
      .attr("data-variant-id", newVariantId);
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__discount")
      .attr("data-variant-id", newVariantId);
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__discount")
      .html(newBadge);

    var mmqBlock = selectedBubble.attr("data-mmq-block");
    var mmqCode = selectedBubble.attr("data-mmq-code");

    $(this)
      .closest(".product-single__add-one")
      .find(".addOneMainInput__js")
      .attr("data-mmq-block", mmqBlock);
    $(this)
      .closest(".product-single__add-one")
      .find(".addOneMainInput__js")
      .attr("data-mmq-code", mmqCode);
    $(this)
      .closest(".product-single__add-one")
      .find(".addOneMainInput__js")
      .attr("data-id", newVariantId);

    if (window.clickedFromPopupColor == false) {
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .prop("checked", true);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .trigger("change");
    }
  });
});
